import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/build-69d35d3ff9407e00083c507e/node_modules/lucide-react/dist/esm/Icon.js");
;
import(/* webpackMode: "eager" */ "/tmp/build-69d35d3ff9407e00083c507e/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/build-69d35d3ff9407e00083c507e/src/app/news-feed/components/NewsFeedClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/build-69d35d3ff9407e00083c507e/src/components/ExchangeRateBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/build-69d35d3ff9407e00083c507e/src/components/SearchBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/build-69d35d3ff9407e00083c507e/src/components/ui/AppLogo.tsx");
